import { filterPromptAI } from "@/api/prompt-ai/filter-prompt-ai";
import { IPromptAI } from "@/interfaces/prompt-ai.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class PromptAIService {
  async filter(
    filter: IFilter<IPromptAI>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IPromptAI>> {
    return await filterPromptAI(filter, pagination);
  }

  async filterAll(
    filter: IFilter<IPromptAI>[],
    batchSize: number
  ): Promise<PaginatedResponse<IPromptAI>> {
    const firstPage = await this.filter(filter, {
      pageNumber: 1,
      pageSize: batchSize,
    });

    const itemsMap = new Map(firstPage.items.map((item) => [item.id, item]));
    let nextPageNumber = firstPage.pageNumber + 1;
    let hasNextPage = firstPage.hasNextPage;

    while (hasNextPage && itemsMap.size < firstPage.totalCount) {
      const page = await this.filter(filter, {
        pageNumber: nextPageNumber,
        pageSize: batchSize,
      });

      page.items.forEach((item) => {
        itemsMap.set(item.id, item);
      });

      hasNextPage = page.hasNextPage;
      nextPageNumber = page.pageNumber + 1;
    }

    const items = Array.from(itemsMap.values());

    return {
      items,
      totalCount: Math.max(firstPage.totalCount, items.length),
      pageNumber: 1,
      pageSize: items.length,
      hasNextPage: false,
      hasPreviousPage: false,
    };
  }
}

const promptAIService = new PromptAIService();

export default promptAIService;
